import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface GlobalError {
  message: string;
}

export interface UiState {
  globalError: GlobalError | null;
  isUILoading: boolean;
  encounteredError: boolean;
  customErrorMessage: string | null;
}

const initialState: UiState = {
  globalError: null,
  encounteredError:false,
  customErrorMessage: null,
  isUILoading: false,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setGlobalError: (state, action: PayloadAction<GlobalError>) => {
      state.globalError = action.payload;
    },
    setEncounteredError: (state, action: PayloadAction<boolean>) => {
        state.encounteredError = action.payload;
      },
    setCustomErrorMessage: (state, action: PayloadAction<string | null>) => {
        state.customErrorMessage = action.payload;
      },
    clearGlobalError: (state) => {
      state.globalError = null;
    },
    setUILoading: (state, action: PayloadAction<boolean>) => {
      state.isUILoading = action.payload;
    },
  },
});

export const { setGlobalError, setEncounteredError, clearGlobalError, setUILoading, setCustomErrorMessage } = uiSlice.actions;

export default uiSlice.reducer;
